// this is an autogenerated file from App/Account/Content/Settings/Content/PaymentProviders/Accounts/mutation-save-settings.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_PaymentProviders_Accounts(
  $account_id: String!
  $location_id: uuid!
  $is_pay_app_enabled: Boolean!
  $fee_mode: fee_mode_enum!
  $card_fee_percent: numeric
  $ach_fee_percent: numeric
  $fee_acknowledged_by_user_id: uuid
) {
  payments_update_settings(
    account_id: $account_id
    location_id: $location_id
    is_pay_app_enabled: $is_pay_app_enabled
    fee_mode: $fee_mode
    card_fee_percent: $card_fee_percent
    ach_fee_percent: $ach_fee_percent
    fee_acknowledged_by_user_id: $fee_acknowledged_by_user_id
  ) {
    ok
  }
}

`